/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { Link } from '@az/starc-ui';
import styles from './styles.module.scss';
import { routePaths } from '@/constants/routePaths';
import { useLabels } from '@/hooks/useLabels';
import { useActionCandidates } from '../../context/ActionCandidatesProvider';

const labelMap = {
  reviewMoreItems: 'label_review_more_items',
  viewMoreItems: 'label_view_more_in_order_history',
};

export const MoreItems = () => {
  const { isReviewCandidates } = useActionCandidates();
  const labels = useLabels(labelMap);

  return (
    <FlexGrid justifyContent={'center'} alignItems={'center'} className={styles.moreItems}>
      <Link
        href={isReviewCandidates ? routePaths.writeReviewPath : routePaths.userOrderHistory}
        attributes={{ 'data-testid': 'more_items_test' }}
      >
        {isReviewCandidates ? labels.reviewMoreItems : labels.viewMoreItems}
      </Link>
    </FlexGrid>
  );
};
